// src/contexts/socketContext.js

import React, { createContext, useEffect } from 'react';
import { io } from 'socket.io-client';

// Create Socket Context
const SocketContext = createContext();

// Create a shared socket instance (only one connection)
const socket = io(); 

// Provider component to wrap the entire app
const SocketProvider = ({ children }) => {
    useEffect(() => {
        console.log('Socket connection established');

        // Cleanup socket connection on unmount
        return () => {
            console.log('Socket connection closed');
            socket.disconnect();
        };
    }, []);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};

export { SocketContext, SocketProvider };
